import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

// GET WITHDRAWALS LIST
function* getWithdrawals({ payload }) {
  try {
    const { data, status } = yield call(api.transfer.getWithdrawals, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_WITHDRAWALS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_WITHDRAWALS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* withdrawals() {
  yield takeLatest(types.GET_WITHDRAWALS_START, getWithdrawals);
}
